/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { readEventRequestV4Schema } from './readEventRequestV4Schema'
import { readEventResponseV4ApiResponseObjectV4Schema } from './readEventResponseV4ApiResponseObjectV4Schema'

export const meReadEventStatus200Schema = readEventResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const meReadEventStatus404Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const meReadEventResponseSchema = meReadEventStatus200Schema

export const meReadEventErrorSchema = meReadEventStatus404Schema

export const meReadEventBodySchemaJsonPatchJson = readEventRequestV4Schema
  .optional()
  .describe('The coded id of the clicked event.')

export const meReadEventBodySchemaJson = readEventRequestV4Schema
  .optional()
  .describe('The coded id of the clicked event.')

export const meReadEventBodySchemaJson2 = readEventRequestV4Schema
  .optional()
  .describe('The coded id of the clicked event.')

export const meReadEventBodySchemaJson3 = readEventRequestV4Schema
  .optional()
  .describe('The coded id of the clicked event.')

export const meReadEventBodySchema = z.union([
  meReadEventBodySchemaJsonPatchJson,
  meReadEventBodySchemaJson,
  meReadEventBodySchemaJson2,
  meReadEventBodySchemaJson3,
])
